module.exports = __webpack_public_path__ + "static/meta-preview-f3cc694fa96924272f0630c72728f258.jpg";